<template>
  <div v-if="group_index !== undefined && groups[group_index]">
    <div
      v-for="(param, index) in groups[group_index].parameters"
      :key="index"
      @click="$emit('input', index)"
    >
      <div :class="{ active: value == index }" class="value-card">
        <div v-if="false" class="image">
          <img
            alt=" "
            :src="param.picture"
          />
        </div>
        <div class="description">
          <div class="c-title">
            {{ param.name }}
            <span
              v-if="attributes[param.code] && attributes[param.code].price > 0"
              class="supplement"
              >+{{ attributes[param.code].price }} &euro;</span
            >
          </div>
          <div v-if="attributes[param.code]">
            <span v-if="attributes[param.code] instanceof Object">{{
              attributes[param.code].name
            }}</span>
            <span v-else>{{ attributes[param.code] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.value-card.active {
  background-color: #d7dce7;
  border: 1px solid #d7dce7;
}

.value-card {
  border: 1px solid #eee;
  display: flex;
  margin-bottom: 5px;
  cursor: pointer;
  min-height: 50px;
  position: relative;
}

.value-card .image {
  width: 50px;
  height: 50px;
}

.value-card .image img {
  width: 50px;
  height: 50px;
}

.value-card .description {
  padding: 0 5px;
}

.value-card .description .c-title {
  font-weight: bold;
}

.value-card .supplement {
  position: absolute;
  right: 10px;
  top: 5px;
  color: black;
}

.value-card.active .supplement {
  color: black;
}
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AttributeSelector',
  props: {
    group_index: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      groups: 'getGroups',
      currentShirt: 'getCurrentShirt'
    }),
    attributes() {
      const group = this.groups[this.group_index]
      return this.currentShirt.options[group.id]
    }
  },
  mounted() {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// AttributeSelector.vue?37cf7873